import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/constants";

export const Testimonials = () => {
    const [idx, setIdx] = useState(0);
    const total = TESTIMONIALS.length;
    const next = () => setIdx((i) => (i + 1) % total);
    const prev = () => setIdx((i) => (i - 1 + total) % total);
    const t = TESTIMONIALS[idx];

    return (
        <section data-testid="testimonials" className="bg-[#1A362B] text-white">
            <div className="container-prose py-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 items-start">
                    <div className="lg:col-span-4">
                        <div className="overline text-[#C69C6D]">Client stories</div>
                        <h2 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight leading-[1.05] font-medium">
                            Trusted by families and investors across Australia.
                        </h2>
                        <div className="divider-thin my-8" />
                        <p className="text-white/70 leading-relaxed">
                            Real outcomes from real clients — read why Australians choose Finance Wealth for their
                            home loans, refinance and investment finance.
                        </p>
                    </div>

                    <div className="lg:col-span-8">
                        <div className="bg-white/5 backdrop-blur p-10 md:p-14 border border-white/10 rounded-sm relative">
                            <Quote className="w-14 h-14 text-[#C69C6D]/40 absolute top-6 right-6" />
                            <div className="font-serif text-xl md:text-2xl text-[#C69C6D] tracking-tight">{t.title}</div>
                            <p className="mt-6 text-lg md:text-xl text-white/90 font-light leading-relaxed font-serif italic">
                                "{t.body}"
                            </p>
                            <div className="mt-10 flex items-center justify-between">
                                <div>
                                    <div className="font-medium">{t.author}</div>
                                    <div className="text-xs tracking-widest uppercase text-white/50 mt-1">{t.location}</div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={prev}
                                        data-testid="testimonial-prev"
                                        className="w-11 h-11 grid place-items-center border border-white/20 rounded-sm hover:bg-[#C69C6D] hover:border-[#C69C6D] transition"
                                        aria-label="Previous"
                                    >
                                        <ChevronLeft className="w-5 h-5" />
                                    </button>
                                    <button
                                        onClick={next}
                                        data-testid="testimonial-next"
                                        className="w-11 h-11 grid place-items-center border border-white/20 rounded-sm hover:bg-[#C69C6D] hover:border-[#C69C6D] transition"
                                        aria-label="Next"
                                    >
                                        <ChevronRight className="w-5 h-5" />
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className="mt-6 flex gap-1.5">
                            {TESTIMONIALS.map((_, i) => (
                                <button
                                    key={i}
                                    onClick={() => setIdx(i)}
                                    data-testid={`testimonial-dot-${i}`}
                                    className={`h-1 rounded-full transition-all ${
                                        i === idx ? "w-10 bg-[#C69C6D]" : "w-5 bg-white/20 hover:bg-white/40"
                                    }`}
                                    aria-label={`Go to testimonial ${i + 1}`}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
